import { useState } from 'react';
import { useRouter } from 'next/router';
import Link from 'next/link';
import Text from '@components/common/text';
import { useLoginModal } from '@components/loginModal/LoginModalContext';
import Comment from './comment';
import Modals from './modals';
import PassReviewPostGetRs from '@domain/rs/passReview/PassReviewPostGetRs';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import useModals from '@utils/hooks/useModals';
import { RouteUrl } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface ItemProps {
  question: string;
  answer: string;
}
const Item = ({ question, answer }: ItemProps) => {
  return (
    <div>
      <Text fontStyle={FontStyle.H4_B}>{question}</Text>
      <Text
        fontStyle={FontStyle.B1P_M}
        color={Colors.C_COOL_GRAY_70}
        styles={{ marginTop: 24, whiteSpace: 'pre-wrap' }}
      >
        {answer}
      </Text>
    </div>
  );
};

interface Props {
  reviewData: PassReviewPostGetRs;
}

const CommentList = ({ reviewData }: Props) => {
  const { query, push } = useRouter();
  const { modalState, openModal, closeModal } = useModals(['review_delete', 'comment_delete']);
  const [commentSn, setCommentSn] = useState<number | null>(null);
  const { openLoginModal, isLogin } = useLoginModal();

  const openCommentDeleteModal = (sn: number) => {
    setCommentSn(sn);
    openModal('comment_delete');
  };

  const onClickWriteBtn = () => {
    if (!isLogin) return openLoginModal();
    push(`${RouteUrl.PASSBOARD}/new`);
  };

  const questionListEl = reviewData.answers.map((answer) => {
    return <Item key={answer.question.questionSn} question={answer.question.question} answer={answer?.answer || ''} />;
  });

  return (
    <>
      <div className={cx('answerArea')}>{questionListEl}</div>

      <div className={cx('divider')} />

      <div className={cx('btnArea')}>
        {!reviewData.userPost ? (
          <button className={cx('btn', 'black')} onClick={onClickWriteBtn}>
            후기 작성
          </button>
        ) : (
          <div className={cx('edit')}>
            <Link className={cx('btn')} href={`${RouteUrl.PASSBOARD}/${query.sn}/edit`}>
              수정
            </Link>
            <button className={cx('btn')} onClick={() => openModal('review_delete')}>
              삭제
            </button>
          </div>
        )}

        <Link className={cx('btn', 'white')} href={RouteUrl.PASSBOARD}>
          목록
        </Link>
      </div>

      <div className={cx('commentArea')}>
        <Comment openCommentDeleteModal={openCommentDeleteModal} />
      </div>

      <Modals modalState={modalState} commentSn={commentSn} setCommentSn={setCommentSn} onClose={closeModal} />
    </>
  );
};

export default CommentList;
